export default __webpack_public_path__ + "static/media/fa.bundle.567b5d1c.svg";